<template>
  <div class="alert-card">
    <div
      v-if="display === 'button-with-icon'"
      class="alert-content button-with-icon-wrapper"
    >
      <h4>{{ primaryHeading }}</h4>
      <div class="button-container">
        <Button class="alert-button" :text="buttonText" @click="action" />
        <round-button-with-icon
          class="alert-icon"
          :icon="icon"
          @click="action()"
        />
      </div>
    </div>
    <div v-if="display === 'three-line-heading'" class="alert-content">
      <h4>{{ primaryHeading }}</h4>
      <h1>{{ middleHeading }}</h1>
      <h4 v-if="lowerHeading" class="right-aligned">{{ lowerHeading }}</h4>
    </div>
    <div v-if="display === 'scroll-window'" class="alert-content">
      <h4 v-if="primaryHeading">{{ primaryHeading }}</h4>
      <div class="scroll-window">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import Button from "./Button.vue";

import RoundButtonWithIcon from "./RoundButtonWithIcon.vue";

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    action() {
      this.$emit("action-taken");
    },
  },
  created() {},
  components: {
    Button,
    RoundButtonWithIcon,
  },
  props: [
    "display",
    "primaryHeading",
    "middleHeading",
    "lowerHeading",
    "button-text",
    "icon",
  ],
  emits: ["action-taken"],
};
</script>
<style scoped>
@media screen {
  .alert-card {
    height: 150px;
    width: 350px;
    flex: 0 0 300px;
    background-color: var(--secondaryColor);
    margin: 5px 10px;
    border-radius: 20px;
    box-shadow: 0px 2px 4px var(--secondaryColor);
  }

  .alert-content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .scroll-window {
    height: 100%;
    overflow: scroll;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;
  }

  h1 {
    justify-self: center;
    font-size: 1.25rem;
    margin: auto;
  }

  h4 {
    font-size: 0.8em;
    text-align: left;
    margin: 15px 20px;
  }

  .right-aligned {
    text-align: right;
  }

  .button-with-icon-wrapper {
    align-items: flex-start;
    justify-content: space-around;
  }

  .button-container {
    display: flex;
    align-items: center;
    align-self: center;
    margin-bottom: auto;
    margin-top: auto;
  }

  .alert-button,
  .alert-icon {
    background-color: var(--contrastColor);
    color: var(--backgroundColor);
    filter: drop-shadow(0px 0px 2px var(--shadow));
    margin-right: 10px;
  }

  @media (min-width: 800px) {
    .alert-card {
      width: 300px;
      flex: 0 0 280px;
      height: 160px;
    }
  }
  @media (min-width: 1200px) {
    .alert-card {
      flex: 0 0 300px;
      height: 180px;
      width: 300px;
    }
  }
}
</style>
